import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';

function Button({ route, icon, children, position = 'left', className = '', modalInstance = false }) {
  return (
    <NavLink
      to={route}
      className={`f4 mt3 link dim ba bw1 ph3 pv2 mb2 dib black-text btn_blue waves-effect waves-dark-blue ${position} ${className}`}
      // close modal if this button was located on a modal. Bugfix (Issue: LK-17)
      onClick={() => {
        if (modalInstance) {
          modalInstance[0].close();
        }
      }}
    >
      <i className="material-icons md-36">{icon}</i> {children}
    </NavLink>
  );
}

Button.propTypes = {
  children: PropTypes.string.isRequired,
  route: PropTypes.string.isRequired,
};

export default Button;
